import {
  Redirect,
  Route,
  RouteChildrenProps,
  Switch,
  useRouteMatch,
} from 'react-router';
import { Queue } from '@rossum/api-client/queues';
import { useSchema } from '../../../business/schema/useSchema';
import { RulesPage } from '../rules';
import { CreateRulePage } from '../rules/pages/CreateRulePage';
import { EditRulePage } from '../rules/pages/EditRulePage';

type RulesRouteProps = RouteChildrenProps & {
  currentQueue: Queue;
  workspaceName: string;
};

export const RulesRoute = ({
  location,
  currentQueue,
  workspaceName,
  match: parentMatch,
}: RulesRouteProps) => {
  const { data } = useSchema(currentQueue.schema);
  const match = useRouteMatch();

  const parentPath = parentMatch?.url ?? '';

  return (
    <Switch location={location}>
      <Route path={`${match.path}`} exact>
        <RulesPage
          queue={currentQueue}
          parentPath={parentPath}
          workspaceName={workspaceName}
        />
      </Route>
      <Route path={`${match.path}/:ruleId?/detail`} exact>
        {data
          ? routeChildrenProps => {
              const ruleId = Number(routeChildrenProps.match?.params.ruleId);

              return (
                <EditRulePage
                  // Key is important for re-mount when navigating to newly created rule
                  key={ruleId}
                  queue={currentQueue}
                  ruleId={ruleId}
                  parentPath={parentPath}
                  workspaceName={workspaceName}
                />
              );
            }
          : null}
      </Route>
      <Route path={`${match.path}/new`} exact>
        {data ? (
          <CreateRulePage
            queue={currentQueue}
            parentPath={parentPath}
            workspaceName={workspaceName}
          />
        ) : null}
      </Route>
      <Route path={`${match.path}`}>
        <Redirect
          to={{
            pathname: `${match.url}`,
            state: location.state,
          }}
        />
      </Route>
    </Switch>
  );
};
